import styles from './Draggable.module.scss';

const PORTAL_ROOT_ID = 'draggable-root';

export const ensurePortalRoot = () => {
  let portalRoot = document.getElementById(PORTAL_ROOT_ID);
  if (portalRoot) {
    return portalRoot;
  }

  portalRoot = document.createElement('div');
  portalRoot.id = PORTAL_ROOT_ID;
  portalRoot.className = styles.portalRoot;
  document.body.appendChild(portalRoot);
  return portalRoot;
};

export const calculatePositionInRange = (
  value: number,
  min: number,
  max: number,
) => {
  if (max < min) {
    return min;
  }

  return Math.min(Math.max(value, min), max);
};
